import React, { useContext } from 'react';
import classes from './FilterSearchButton.module.scss';
import Button from '@/components/Button/Button';
import { viewportContext } from '@/context/viewport.context';
import t from '@/utils/Language/UI-translations';

const FilterSearchButton = ({ doSearch, hideTextOnMobile = false }) => {
  const { isMobileOrTablet } = useContext(viewportContext);

  return (
    <Button
      dataCy="button-search"
      type="secondary"
      icon={{ style: 'fas', font: 'search' }}
      groupPosition="right"
      additionalClasses={classes.searchButton}
      text={isMobileOrTablet && hideTextOnMobile ? '' : t('Search')}
      onButtonClick={doSearch}
    />
  );
};

export default FilterSearchButton;
